var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDotsPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 72,
    viewBox: "0 0 46 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ujzbpatvwa",
    d: "M0 0.242L44.758 0.242 44.758 45 0 45z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5FB6B",
    d: "M20.983 31.046H24.355V71.04599999999999H20.983z",
    transform: "translate(-509 -280) translate(32 160) translate(477 120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A82FF",
    d: "M19.297 68.706h6.745c.931 0 1.686.755 1.686 1.686v1.686H17.611v-1.686c0-.931.755-1.686 1.686-1.686z",
    transform: "translate(-509 -280) translate(32 160) translate(477 120)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-509 -280) translate(32 160) translate(477 120) translate(.103 .738) translate(0 .152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tj4wx8ilzb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ujzbpatvwa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5FB6B",
    d: "M44.758 22.621c0 12.36-10.02 22.38-22.38 22.38C10.02 45 0 34.98 0 22.62S10.02.242 22.379.242c12.36 0 22.379 10.02 22.379 22.38",
    mask: "url(#tj4wx8ilzb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06F3F9",
    d: "M22.52 39.998c-5.35 0-10.061-3.221-12.002-8.206-.348-.893.094-1.899.987-2.246.893-.348 1.899.093 2.247.986 1.418 3.642 4.86 5.995 8.768 5.995 3.91 0 7.352-2.353 8.77-5.994.347-.893 1.353-1.335 2.246-.987.893.347 1.335 1.353.987 2.246-1.94 4.985-6.652 8.206-12.003 8.206M28.987 18.92c-1.285 0-2.331 1.046-2.331 2.332 0 1.285 1.046 2.33 2.33 2.33 1.286 0 2.332-1.045 2.332-2.33 0-1.286-1.046-2.332-2.331-2.332m0 7.97c-3.109 0-5.638-2.53-5.638-5.638 0-3.11 2.529-5.639 5.638-5.639s5.638 2.53 5.638 5.639c0 3.108-2.53 5.638-5.638 5.638M16.061 16.03v2.664c0 .125.101.226.226.226h2.046v2.197c0 1.254-1.026 2.307-2.28 2.286-1.218-.02-2.202-1.018-2.202-2.242v-7.89c0-1.247 1.021-2.3 2.27-2.284 1.143.014 2.083.89 2.2 2.006.011.116.106.206.223.206h3.043c.129 0 .232-.108.226-.237-.14-3.057-2.688-5.497-5.788-5.462-3.15.036-5.661 2.65-5.661 5.8v7.789c0 3.153 2.518 5.77 5.671 5.8 3.185.031 5.785-2.55 5.785-5.728v-2.24h.004v-3.005c0-.062-.05-.112-.113-.112h-5.424c-.125 0-.226.1-.226.225",
    transform: "translate(-509 -280) translate(32 160) translate(477 120) translate(.103 .738)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDotsPin);
export default __webpack_public_path__ + "static/media/dashboard-dots-pin.daf821132fc8f9546412e609949f5592.svg";
export { ForwardRef as ReactComponent };